if (!customElements.get('line-item')) {
  class LineItem extends HTMLElement {
    constructor() {
      super();
    }

    static currenciesWithoutDecimals = [
      'BIF', // Burundian Franc
      'CLP', // Chilean Peso
      'DJF', // Djiboutian Franc
      'GNF', // Guinean Franc
      'ISK', // Icelandic Króna
      'JPY', // Japanese Yen
      'KMF', // Comorian Franc
      'KRW', // South Korean Won
      'PYG', // Paraguayan Guarani
      'RWF', // Rwandan Franc
      'UGX', // Ugandan Shilling
      'VND', // Vietnamese Đồng
      'VUV', // Vanuatu Vatu
      'XAF', // Central African CFA Franc
      'XOF', // West African CFA Franc
      'XPF', // CFP Franc
    ];

    /**
     * Formats a number as currency.
     *
     * @param {Number} amount - The amount to format. Using the same format
     * as shopify's filters: 9000 is 90.00 for decimal currencies.
     * @returns {String} The formatted currency string.
     */
    formatCurrency(amount) {
      const divisor = LineItem.currenciesWithoutDecimals.includes(
        window.currency,
      )
        ? 1
        : 100;

      return new Intl.NumberFormat(window.shopLocale, {
        style: 'currency',
        currency: window.currency,
      }).format(amount / divisor);
    }

    updateSavePerItem(activeButton) {
      // js-save-per-item
      if (
        !this.savePerItemElement ||
        !activeButton ||
        !this.pricePerItemElement
      )
        return;

      const originalPrice =
        Number(this.previousActiveButton.getAttribute('data-price-per-item')) ??
        Number(this.pricePerItemElement.getAttribute('data-original-price'));

      const pricePerItem = Number(
        activeButton.getAttribute('data-price-per-item'),
      );

      let priceDifference =
        ((originalPrice - Math.floor(pricePerItem)) / originalPrice) * 100;

      this.savePerItemElement.textContent =
        ' ' + parseFloat(priceDifference.toFixed(1)).toString() + '%';
    }

    updateTotalPrice(pricePerItem) {
      // js-total-price
      if (!this.totalPriceElement) return;

      const total = Math.floor(pricePerItem) * this.quantityInput.value;

      this.totalPriceElement.textContent = this.formatCurrency(total);

      this.totalPriceElement.setAttribute('data-total-price', total);

      document.dispatchEvent(new CustomEvent('cart:calculate-total'));
    }

    updatePricePerItem(prevActiveButton) {
      // js-price-per-item
      if (!this.pricePerItemElement) return;

      const pricePerItem = prevActiveButton
        ? Number(prevActiveButton.getAttribute('data-price-per-item'))
        : Number(this.pricePerItemElement.getAttribute('data-original-price'));

      this.pricePerItemElement.textContent = this.formatCurrency(pricePerItem);

      return pricePerItem;
    }

    findLastActiveButton() {
      let lastIndexWithoutProperty = -1;

      for (let i = 0; i < this.wholesaleButtons.length; i++) {
        if (!this.wholesaleButtons[i].hasAttribute('js-active')) {
          lastIndexWithoutProperty = i;
          continue;
        }

        break;
      }

      return lastIndexWithoutProperty !== -1
        ? this.wholesaleButtons[lastIndexWithoutProperty]
        : null;
    }

    updatePrices() {
      const activeButton = this.wholesaleButtons.find((button) =>
        button.hasAttribute('js-active'),
      );

      let prevActiveButton = this.findLastActiveButton();

      // Always in this order
      const pricePerItem = this.updatePricePerItem(prevActiveButton);
      this.updateTotalPrice(pricePerItem);
      this.updateSavePerItem(activeButton);
    }

    handleQuantityChange(event) {
      if (!event.isTrusted) return (this.style.pointerEvents = 'none');
    }

    handleWholesaleQuantityChange(event) {
      this.quantityInput.value = event.detail.quantity;

      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setActiveButton() {
      this.previousActiveButton = null;
      let button = null;

      for (let i = 0; i < this.wholesaleButtons.length; i++) {
        button = this.wholesaleButtons[i];

        if (
          this.quantityInput.value >=
          Number(button.getAttribute('data-min-quantity'))
        ) {
          button.removeAttribute('js-active');
          this.previousActiveButton = button;
          continue;
        }

        button.setAttribute('js-active', '');
        button.classList.remove('hidden');
        break;
      }
    }

    connectedCallback() {
      this.wholesaleButtons = Array.from(
        this.querySelectorAll(
          `[data-variant-id="${this.getAttribute('data-variant-id')}"]`,
          'js-active',
        ),
      );

      if (!this.wholesaleButtons.length) return;

      this.wholesaleButtons.sort(
        (a, b) =>
          Number(a.getAttribute('data-min-quantity')) -
          Number(b.getAttribute('data-min-quantity')),
      );

      for (let i = 1; i < this.wholesaleButtons.length; i++) {
        this.wholesaleButtons[i].removeAttribute('js-active');
      }

      this.quantityInput = this.querySelector('[name="quantity"]');

      if (!this.quantityInput) return;

      this.quantity = this.quantityInput.value;

      this.quantityInput.addEventListener(
        'change',
        this.handleQuantityChange.bind(this),
      );

      this.addEventListener(
        'wholesale:quantity-change',
        this.handleWholesaleQuantityChange.bind(this),
      );

      this.savePerItemElement = this.querySelector('[js-save-per-item');
      this.totalPriceElement = this.querySelector('[js-total-price]');
      this.pricePerItemElement = this.querySelector('[js-price-per-item]');

      this.setActiveButton();

      this.updatePrices();

      this.addEventListener(
        'line-item:update-prices',
        this.updatePrices.bind(this),
      );
    }
  }

  customElements.define('line-item', LineItem);
}
